import React from "react";

const AlertsView = React.lazy(() => import("./Alerts.view"));

const AlertsLoadable = () => <AlertsView />;

export default () => <AlertsLoadable />;
